import React, { useMemo } from 'react';
import { Form, Input } from 'antd';
import AppModal from '@/pages/inside/tenant/AppModal';
import { Button } from '@/components/ui/Button';
import { CreateRoleModalBody, CreateRoleModalFooter } from '@/pages/inside/tenant/style';
import { LINK_URL_EXAMPLE_HELP, normalizeUrlOnFirstType, validateLinkUrlInput } from '@utils/linkUrlValidation.jsx';
import styled from 'styled-components';

const LinkModalFormWrap = styled.div`
    .ant-form-item-explain,
    .ant-form-item-explain-error {
        font-size: 12px;
        line-height: 1.25;
        margin-top: 2px;
    }
`;

export default function MilestoneLinkModal({ open, onCancel, linkModalForm, handleLinkModalSubmit }) {
    const urlValue = Form.useWatch('url', linkModalForm);

    const urlStartsOk = useMemo(() => {
        const v = typeof urlValue === 'string' ? urlValue.trim() : '';
        if (!v) return false;
        return /^https:\/\//i.test(v) || /^www\./i.test(v);
    }, [urlValue]);

    const urlHelp = LINK_URL_EXAMPLE_HELP;

    return (
        <AppModal size="sm" title="Add link" open={open} onCancel={onCancel} footer={null}>
            <CreateRoleModalBody>
                <LinkModalFormWrap>
                    <Form form={linkModalForm} layout="vertical">
                        <Form.Item
                            name="url"
                            label="URL"
                            rules={[
                                {
                                    validator: async (_, value) => {
                                        const check = validateLinkUrlInput(value);
                                        if (check.ok) return Promise.resolve();
                                        return Promise.reject(new Error(check.message || 'Enter a valid URL'));
                                    },
                                },
                            ]}
                            extra={(linkModalForm?.getFieldError?.('url') || []).length ? null : urlHelp}
                        >
                            <Input
                                placeholder="https://..."
                                onChange={(e) => {
                                    const raw = e?.target?.value ?? '';
                                    const prev = linkModalForm?.getFieldValue?.('url');
                                    const normalized = normalizeUrlOnFirstType(raw, prev);
                                    if (normalized !== raw) {
                                        linkModalForm?.setFieldsValue?.({ url: normalized });
                                    }
                                }}
                            />
                        </Form.Item>
                        <Form.Item name="title" label="Link text">
                            <Input placeholder="Optional display text" />
                        </Form.Item>
                    </Form>
                </LinkModalFormWrap>
            </CreateRoleModalBody>
            <CreateRoleModalFooter>
                <Button $primary={false} $size="14px" onClick={onCancel}>Cancel</Button>
                <Button
                    $primary
                    $blackOnLight
                    $size="14px"
                    disabled={!urlStartsOk}
                    disabledTooltip={!urlStartsOk ? 'URL must start with "https://" or "www." (example: https://example.com)' : undefined}
                    onClick={handleLinkModalSubmit}
                >
                    Add link
                </Button>
            </CreateRoleModalFooter>
        </AppModal>
    );
}
